import { useMutation, useQueryClient } from 'react-query';
import {
  getBettieDailyRandomRewards,
  type GetBettieDailyRandomRewardsResponse
} from '../../../bettie/services/bettieService';

export function useGetBettieRandomRewards() {
  const queryClient = useQueryClient();
  return useMutation<GetBettieDailyRandomRewardsResponse, Error>(
    () => getBettieDailyRandomRewards(),
    {
      onSuccess: () => {
        localStorage.setItem('lastPlayDate', new Date().toISOString());
        queryClient.invalidateQueries(['bettieBalances']);
      }
    }
  );
}
